export const authUserTypeDef = `
  id
  type
`;
